import { Link } from "react-router-dom";
import { categories } from "@/lib/toolsData";
import { Zap } from "lucide-react";

const legal = [
  { to: "/page/about", label: "About" },
  { to: "/page/privacy", label: "Privacy" },
  { to: "/page/terms", label: "Terms" },
  { to: "/page/contact", label: "Contact" },
  { to: "/page/dmca", label: "DMCA" },
  { to: "/blog", label: "Blog" },
];

export const Footer = () => {
  return (
    <footer className="mt-24 border-t border-border bg-muted/40">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                <Zap className="h-4 w-4" strokeWidth={2.5} />
              </span>
              <span className="font-heading text-xl font-bold tracking-tight">Kovi Tools</span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">
              The largest free online toolbox — PDF, converters, calculators and developer tools. Browser-first, no signup.
            </p>
          </div>
          <div>
            <p className="overline text-muted-foreground">Categories</p>
            <div className="mt-3 flex flex-col gap-2">
              {categories.map((c) => (
                <Link key={c.id} to={`/category/${c.id}`} className="text-sm text-muted-foreground transition-colors hover:text-foreground">{c.name}</Link>
              ))}
            </div>
          </div>
          <div>
            <p className="overline text-muted-foreground">Company</p>
            <div className="mt-3 flex flex-col gap-2">
              {legal.map((l) => (
                <Link key={l.to} to={l.to} data-testid={`footer-${l.label.toLowerCase()}`} className="text-sm text-muted-foreground transition-colors hover:text-foreground">{l.label}</Link>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-2 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Kovi Tools — All tools, one place.</span>
          <span className="font-mono-tech">Free forever · Built for the web</span>
        </div>
      </div>
    </footer>
  );
};
